// @flow

const FRANCHISE_STATUS = {
	NOT_ACTIVATED: {
		Name: 'NotActivated',
		Description: 'Неактивна',
	},
	DISABLED: {
		Name: 'Disabled',
		Description: 'Недоступна',
	},
	ACTIVATED: {
		Name: 'Activated',
		Description: 'Активна',
	},
	BLOCKED: {
		Name: 'Blocked',
		Description: 'Заблокирована',
	},
};

const ASSISTANCE_TYPE_SUMMARY_STATUS = {
	FULL: 'Full',
	DISABLED: 'Disabled',
	PARTIAL: 'Partial',
};

const FRANCHISE_BLOCKED_TEXT_CLASS = 'franchise-blocked-text';

const FRANCHISE_LABEL_CLASS = {
	[FRANCHISE_STATUS.NOT_ACTIVATED.Name]: 'franchise-not-activated',
	[FRANCHISE_STATUS.ACTIVATED.Name]: 'franchise-activated',
	[FRANCHISE_STATUS.BLOCKED.Name]: 'franchise-blocked',
};

const FRANCHISE_FILTER_OPTIONS = [
	{
		id: 1,
		__id: 1,
		Name: 'Есть',
		Query: 'yes',
	},
	{
		id: 0,
		__id: 0,
		Name: 'Нет',
		Query: 'no',
	},
];

const FRANCHISE_INFO_STATUS_TEXT = {
	[FRANCHISE_STATUS.NOT_ACTIVATED.Name]: 'Для того, чтобы получать медицинские услуги '
	+ 'с франшизой, необходимо активировать данную опцию, нажав на кнопку «Активировать». '
	+ 'Обращаем Ваше внимание, что процесс активации франшизы по полису ДМС производится '
	+ 'однократно и распространяется на все услуги и медицинские организации, где она применяется',
	[FRANCHISE_STATUS.ACTIVATED.Name]: 'В данный момент франшиза активирована, Вы можете получать '
	+ 'медицинские услуги с франшизой в рамках Вашей программы ДМС',
	[FRANCHISE_STATUS.BLOCKED.Name]: 'Внимание! В настоящее время возможность получения '
	+ 'медицинских услуг в медицинских организациях, в которых предусмотрена франшиза, '
	+ 'заблокирована в связи с задолженностью по ее оплате. Для восстановления возможности '
	+ 'получения этих услуг необходимо погасить задолженность (пополнить карту или привязать '
	+ 'новую). Для этого перейдите, пожалуйста, на вкладку «Франшиза»',
};

const FRANCHISE_INFO_STATUS_CLASS = {
	[FRANCHISE_STATUS.NOT_ACTIVATED.Name]: 'franchise-info-not-activated',
	[FRANCHISE_STATUS.ACTIVATED.Name]: 'franchise-info-activated',
	[FRANCHISE_STATUS.BLOCKED.Name]: 'franchise-info-blocked',
};

const FRANCHISE_LABEL_TEXT = {
	[FRANCHISE_STATUS.NOT_ACTIVATED.Name]: 'Не активирована',
	[FRANCHISE_STATUS.ACTIVATED.Name]: 'Активирована',
	[FRANCHISE_STATUS.BLOCKED.Name]: 'Заблокирована',
};

const FRANCHISE_DIALOG_GREETINGS = {
	[FRANCHISE_STATUS.NOT_ACTIVATED.Name]: 'Добро пожаловать в личный кабинет.',
	[FRANCHISE_STATUS.BLOCKED.Name]: 'Внимание!',
};

const FRANCHISE_DIALOG_STATUS_TEXT = {
	[FRANCHISE_STATUS.NOT_ACTIVATED.Name]: 'Обращаем внимание, что Ваша программа ДМС '
	+ 'предусматривает получение медицинских услуг с франшизой. Это предполагает частичную '
	+ 'оплату Вами стоимости оказанных медицинских услуг. Для того, чтобы получать '
	+ 'медицинские услуги с франшизой, необходимо активировать данную опцию на вкладке '
	+ '«Франшиза». Перейти к активации?',
	[FRANCHISE_STATUS.BLOCKED.Name]: 'В настоящее время возможность получения '
	+ 'медицинских услуг в медицинских организациях, в которых предусмотрена франшиза, '
	+ 'заблокирована в связи с задолженностью по ее оплате. Для восстановления возможности '
	+ 'получения этих услуг необходимо погасить задолженность (пополнить карту или привязать'
	+ ' новую). Для этого перейдите, пожалуйста, на вкладку «Франшиза»',
};

const FRANCHISE_DETAILED_INFORMATION = 'Более подробную информацию о размере франшизы '
	+ 'и медицинских организациях в которых она предусмотрена, Вы можете найти на вкладках '
	+ '«Программа страхования» и «Клиники».';

const FRANCHISE_ACTIVATION_PROCESS = 'Обращаем Ваше внимание, что процесс активации франшизы '
	+ 'по полису ДМС производится однократно и распространяется на все медицинские организации, '
	+ 'где она применяется.';

const PROGRAMS_FRANCHISE_DEFINITION = 'Ваша программа ДМС предусматривает получение медицинских '
	+ 'услуг с франшизой. Это предполагает частичную оплату Вами стоимости оказанных услуг. Более '
	+ 'подробную информацию о размере франшизы и медицинских организациях, в которых она '
	+ 'предусмотрена, Вы можете найти на вкладках «Виды помощи» и «Клиники».';

const MEDICAL_TYPES_FRANCHISE_DEFINITION = 'Ваша программа ДМС предусматривает получение '
	+ 'медицинских услуг с франшизой. Это предполагает частичную оплату Вами стоимости оказанных '
	+ 'услуг. Более подробную информацию о размере франшизы и медицинских организациях, в которых '
	+ 'она предусмотрена, Вы можете найти на вкладке «Клиники».';

const FRANCHISE_SHORT_DEFINITION = 'Ваша программа ДМС предусматривает получение медицинских услуг '
	+ 'с франшизой. Это предполагает частичную оплату Вами стоимости оказанных услуг.';

const FRANCHISE_AUTH_ERROR = 'К сожалению функционал модуля работы с франшизой временно недоступен.'
	+ ' Повторите попытку позднее. Если ошибка повторяется, обратитесь к Администратору.';

const BLOCKED_FRANCHISE_TOOLTIP_TEXT = 'Возможно, у вас есть задолженность по франшизе.';

export {
	FRANCHISE_STATUS,
	FRANCHISE_AUTH_ERROR,
	PROGRAMS_FRANCHISE_DEFINITION,
	MEDICAL_TYPES_FRANCHISE_DEFINITION,
	FRANCHISE_SHORT_DEFINITION,
	FRANCHISE_LABEL_TEXT,
	FRANCHISE_LABEL_CLASS,
	FRANCHISE_FILTER_OPTIONS,
	FRANCHISE_INFO_STATUS_TEXT,
	FRANCHISE_INFO_STATUS_CLASS,
	FRANCHISE_BLOCKED_TEXT_CLASS,
	FRANCHISE_DIALOG_GREETINGS,
	FRANCHISE_DIALOG_STATUS_TEXT,
	ASSISTANCE_TYPE_SUMMARY_STATUS,
	BLOCKED_FRANCHISE_TOOLTIP_TEXT,
	FRANCHISE_DETAILED_INFORMATION,
	FRANCHISE_ACTIVATION_PROCESS,
};
